import { useCallback, useState } from "react";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";

import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { ROTA_APIS } from "@/api_framework/api_config";

AxiosCurlirize(axios, () => {});

export interface IRotaNumberOfSlotRemovedBody {
  staff_id: string;
  date: string;
  start_time: string;
  end_time: string;
  sub_service_ids: string[];
}

export interface IRotaNumberOfSlotRemovedResponse {
  status: boolean;
  message: string;
  data?: {
    booking_count?: number;
    booking_impact?: number;
  };
}

export const useRotaNumberOfSlotRemoved = () => {
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();

  const [loading, setLoading] = useState(false);

  const execute = useCallback(
    async (body: IRotaNumberOfSlotRemovedBody): Promise<IRotaNumberOfSlotRemovedResponse | null> => {
      try {
        setLoading(true);

        const accessToken = localStorage.getItem(
          configuration.localStorage.ACCESS_TOKEN.key
        );

        const response: AxiosResponse<IRotaNumberOfSlotRemovedResponse> =
          await axios.post(
            `${ROTA_APIS?.ROTA_SLOT_REMOVALS?.baseURL || ""}impact/`,
            body,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            }
          );

        return response.data;
      } catch (e: any) {
        const error = e as AxiosError;

        if (error?.config) {
          sendCurl((error.config as any)?.curlCommand);
        }

        captureError(error);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [configuration, captureError, sendCurl]
  );

  return { execute, loading };
};
